export enum AgGridCssClassEnum {
  Edit = 'edit-preview',
  Normal = 'normal-header',
  Source = 'source-header',
}
